<template>
    <div>
         <!-- 保养 -->
      <div v-if="data.type  === 2">
        <info-item label="上次保养里程" :value="data.lastMaintenanceKm"></info-item>
        <info-item label="本次进厂里程" :value="data.incomeKm"></info-item>
        <info-item label="超保里程" :value="data.overMaintenanceKm"></info-item>
        <info-item label="超保费" :value="data.exceedAmount+'元（超保费用单独走应收单线下支付）'"></info-item>
      </div>
      <!-- 维修 -->
      <div v-if="data.type === 1">
        <info-item label="保险上浮费" :value="data.floatAmount+'元 （保险上浮费单独走应收单线下支付）'"></info-item>
        <info-item label="车辆折旧费" :value="data.depreciationAmount+'元 （折旧费单独走应收单线下支付）'"></info-item>
      </div>
    </div>
</template>


<script>
import InfoItem from '@/components/infoItem'

export default {
  components: {
    InfoItem,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
